import { FC, HTMLAttributes } from 'react';

import { ConflictType } from '@/types/Conflicten';

import styles from '../Conflict.module.css';

const ConflictIndicator: FC<HTMLAttributes<HTMLDivElement> & { xl?: boolean; conflictType: ConflictType }> = ({
  conflictType,
  xl = false,
  ...divProps
}) => (
  <div
    className={
      xl ? styles[`conflictKleurVariantsXl--${conflictType}`] : styles[`conflictKleurVariantsSm--${conflictType}`]
    }
    {...divProps}
  />
);

export default ConflictIndicator;
